export const TimezoneDefault = 'America/Los_Angeles';

export const TimeZoneOptions = [
  { key: '1', value: 'America/Chicago', name: 'Chicago' },
  { key: '2', value: 'America/Denver', name: 'Denver' },
  { key: '3', value: 'America/Los_Angeles', name: 'Los Angeles' },
  { key: '4', value: 'America/New_York', name: 'New York' },
  { key: '5', value: 'America/Phoenix', name: 'Phoenix' },
];
